var AT_Main = {
    getWidthBrowser: function() {
        var e;
        return "number" == typeof window.innerWidth ? e = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? e = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientWidth), e
    },
    checkLayout: function() {
        return "block" == jQuery("#checkLayout .visible-xs-block").css("display") ? 1 : "block" == jQuery("#checkLayout .visible-sm-block").css("display") ? 2 : "block" == jQuery("#checkLayout .visible-md-block").css("display") ? 3 : "block" == jQuery("#checkLayout .visible-lg-block").css("display") ? 4 : void 0
    },
    homeSlideshow: function() {
        jQuery(".home-slideshow-wrapper").length && jQuery(".home-slideshow-wrapper").each(function(e, t) {
            var i = "";
            jQuery(t).data("autoplay") && (i = jQuery(t).data("time"));
            new Swiper(".swiper-container", {
                autoplay: i,
                loop: !0,
                pagination: ".swiper-pagination",
                paginationClickable: ".swiper-pagination",
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                spaceBetween: 0,
                scrollbarDraggable: !0,
                effect: jQuery(t).data("animation"),
                setWrapperSize: !1,
                onImagesReady: function(e) {
                    $(e.container[0]).find(".swiper-slide > img").height(), $(e.container[0]).find(".swiper-slide > img").width();
                    $(e.container[0]).find(".swiper-slide > img").css("visibility", "hidden"), $(e.container[0]).find(".swiper-slide").each(function() {
                        var e = $(this);
                        e.find(".video-slide").show(), e.find(".video-slide video").css({
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%,-50%)"
                        })
                    })
                }
            })
        })
    },
    homeIE: function() {
        jQuery(".home-slideshow-wrapper").length && jQuery(".home-slideshow-wrapper").each(function(e, t) {
            var i = "";
            jQuery(t).data("autoplay") && (i = jQuery(t).data("time"));
            new Swiper(".swiper-container", {
                autoplay: i,
                loop: !0,
                pagination: ".swiper-pagination",
                paginationClickable: ".swiper-pagination",
                nextButton: ".swiper-button-next",
                prevButton: ".swiper-button-prev",
                spaceBetween: 30,
                scrollbarDraggable: !0,
                effect: "fade",
                setWrapperSize: !0,
                onImagesReady: function(e) {
                    $(e.container[0]).find(".swiper-slide > img").height(), $(e.container[0]).find(".swiper-slide > img").width();
                    $(e.container[0]).find(".swiper-slide > img").css("visibility", "hidden"), $(e.container[0]).find(".swiper-slide").each(function() {
                        var e = $(this);
                        e.find(".video-slide").show(), e.find(".video-slide video").css({
                            left: "50%",
                            top: "50%",
                            transform: "translate(-50%,-50%)"
                        })
                    })
                }
            })
        })
    },
    stickMenu: function() {
        var e = jQuery(".header-content").data("stick");
        if (e) {
            var t = 0,
                i = jQuery(".header-middle"),
                n = jQuery("#body-content");
            jQuery(window).scroll(function() {
                var e = jQuery(this).scrollTop();
                e > t ? e > 250 && (i.addClass("header-fixed fadeIn animated"), n.addClass("has-header-fixed")) : 250 > e && (i.removeClass("header-fixed fadeIn animated"), n.removeClass("has-header-fixed")), t = e
            })
        }
    },
    toTopButton: function() {
        var e = $("#scroll-to-top");
        1 > e.length || ($(window).on("scroll", function() {
            var e = jQuery(this).scrollTop(),
                t = jQuery(this).height();
            if (e > 100) var i = e + t / 2;
            else var i = 1;
            1e3 > i && t > i ? jQuery("#scroll-to-top").removeClass("on off").addClass("off") : jQuery("#scroll-to-top").removeClass("on off").addClass("on")
        }), e.on("click", function(e) {
            e.preventDefault(), jQuery("body,html").animate({
                scrollTop: 0
            }, 800, "swing")
        }))
    },
    mailchipPopup: function() {
        var e = jQuery("#mailchimp-popup").data("expires");
        jQuery.cookie("mycookie") || jQuery.fancybox(jQuery("#mailchimp-popup"), {
            autoDimensions: !1,
            width: 730,
            height: 390,
            autoSize: !1,
            transitionIn: "none",
            transitionOut: "none"
        }), jQuery.cookie("mycookie", "true", {
            expires: e
        })
    },
    handleGridList: function() {
        "yes" == $.cookie("cata-grid-extended") && $("body").addClass("cata-grid-extended"), "yes" == $.cookie("cata-list") && $("body").addClass("cata-list"), "yes" == $.cookie("cata-list-small") && $("body").addClass("cata-list-small"), jQuery("body").on("click", ".grid", function() {
            jQuery(this).closest(".grid-list");
            $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list"), jQuery("body").removeClass("cata-list-small")
        }), jQuery("body").on("click", ".grid-extended", function() {
            jQuery(this).closest(".grid-list");
            $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-grid-extended", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-list"), jQuery("body").removeClass("cata-list-small"), jQuery("body").addClass("cata-grid-extended")
        }), jQuery("body").on("click", ".list", function() {
            jQuery(this).closest(".grid-list");
            $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list-small"), jQuery("body").addClass("cata-list")
        }), jQuery("body").on("click", ".list-small", function() {
            jQuery(this).closest(".grid-list");
            $.cookie("cata-grid-extended", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list", "no", {
                expires: 1,
                path: "/"
            }), $.cookie("cata-list-small", "yes", {
                expires: 1,
                path: "/"
            }), jQuery("body").removeClass("cata-grid-extended"), jQuery("body").removeClass("cata-list"), jQuery("body").addClass("cata-list-small")
        })
    },
    effectNavigation: function() {
        jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(e) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").addClass("fadeInUp animated")
        }, function(e) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").removeClass("fadeInUp animated")
        }), jQuery(".vertical-menu .navigation .navbar-collapse .main-nav>li").hover(function(e) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").addClass("fadeInRight animated")
        }, function(e) {
            jQuery(this).find(">.dropdown-menu, >.dropdown-menu li >.dropdown-menu").removeClass("fadeInRight animated")
        }), jQuery(".cart-target").hover(function(e) {
            jQuery(this).find(">.dropdown-menu").addClass("fadeInUp animated")
        }, function(e) {
            jQuery(this).find(">.dropdown-menu").removeClass("fadeInUp animated")
        }), jQuery(".currency-block").hover(function(e) {
            jQuery(this).find(">.dropdown-menu").addClass("fadeInUp animated")
        }, function(e) {
            jQuery(this).find(">.dropdown-menu").removeClass("fadeInUp animated")
        })
    },
    fancyboxHomeThumbProduct: function() {
        jQuery(".thumb-item-img").fancybox({
            prevEffect: "none",
            nextEffect: "none",
            closeBtn: !1,
            helpers: {
                title: {
                    type: "inside"
                },
                buttons: {}
            }
        })
    },
    fixNoScroll: function() {
        var e = jQuery(window).width();
        jQuery("#page-body, .header-content, #page-body .mobile-version").css("width", e + "px")
    },
    fixReturnScroll: function() {
        jQuery("#page-body, .header-content,#page-body .mobile-version").attr("style", "")
    },
    fixButton: function() {
        jQuery(".product-wrapper .product-head").each(function(e) {
            $(this).children().hasClass("wrapper-countdown") && $(this).find(".product-button").addClass("fix")
        })
    },
    handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges()
    },
    menuOnMobile: function() {
        jQuery("#page-body").on("click", function() {
            jQuery(".menu-mobile").removeClass("opened"), jQuery("html,body").removeClass("menu-opened"), AT_Main.fixReturnScroll()
        }), jQuery(document).on("click", "[data-toggle=offcanvas]", function(e) {
            e.stopPropagation(), AT_Main.fixNoScroll(), jQuery(".menu-mobile").toggleClass("opened"), jQuery("html,body").toggleClass("menu-opened")
        }), jQuery(".navbar .main-nav li").hover(function() {
            jQuery(this).addClass("hover")
        }, function() {
            jQuery(this).removeClass("hover")
        }), jQuery(document).on("click", ".mobile-version .menu-mobile .main-nav .expand", function() {
            var e = jQuery(this).parents(".dropdown").first();
            e.hasClass("menu-mobile-open") ? (e.removeClass("menu-mobile-open"), $(this).find(".visible-xs").removeClass("fa-minus"), $(this).find(".visible-xs").addClass("fa-plus")) : (e.addClass("menu-mobile-open"), $(this).find(".visible-xs").removeClass("fa-plus"), $(this).find(".visible-xs").addClass("fa-minus"))
        }), jQuery(document).on("click", ".sb-categories .s-expand", function() {
            var e = jQuery(this).parents(".dropdown").first();
            e.hasClass("s-open") ? (e.removeClass("s-open"), $(this).find(".s-plus").removeClass("fa-angle-up"), $(this).find(".s-plus").addClass("fa-angle-right")) : (e.addClass("s-open"), $(this).find(".s-plus").removeClass("fa-angle-right"), $(this).find(".s-plus").addClass("fa-angle-up"))
        })
    },
    handleMenuMultiLine: function() {
        var e = "",
            t = !1;
        jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(i) {
            var n = jQuery(i.currentTarget);
            t && "" != e ? (e.addClass("hold"), setTimeout(function() {
                "" != e && e.removeClass("hold"), t = !1, e = ""
            }, 500), (e[0] == n[0] || e.offset().top == n.offset().top) && (e.removeClass("hold"), t = !1, e = "")) : e = ""
        }), jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(i) {
            var n = jQuery(i.currentTarget);
            i.pageY >= n.offset().top + 50 && (t = !0), n.hasClass("dropdown") && "" == e && (e = n)
        })
    },
    toggleFilterSidebar: function() {
        jQuery(document).on("click", ".filter-toggle", function(e) {
            e.stopPropagation(), AT_Main.fixNoScroll(), jQuery(".sbw-filter").toggleClass("opened"), jQuery("html,body").toggleClass("filter-opened")
        }), jQuery(document).on("click", "#page-body", function(e) {
            jQuery(".sbw-filter").removeClass("opened"), jQuery("html,body").removeClass("filter-opened")
        })
    },
    dropdownFilter: function() {
        jQuery(document).on("click", ".sb-filter .sbf-title>span", function(e) {
            e.stopPropagation(), jQuery(this).toggleClass("none-active"), jQuery(this).closest(".sb-filter").find(".advanced-filters").toggleClass("hide")
        })
    },
    toggleFooter: function() {
        jQuery(document).on("click", ".footer-block h3>span", function(e) {
            jQuery(this).closest(".footer-block").find("h3").toggleClass("opened"), jQuery(this).closest(".footer-block").find(".list-links").slideToggle()
        })
    },
    toggleVerticalMenu: function() {
        jQuery(document).on("click", ".vertical-menu .head", function(e) {
            jQuery(this).parent().toggleClass("opened"), jQuery(this).parent().find(".navbar").slideToggle()
        })
    },
    fixTitle: function() {
        jQuery(".rt a").attr("data-title", function() {
            return jQuery(this).attr("title")
        }), jQuery(".rt a").removeAttr("title")
    },
    filterCatalogReplace: function() {
        var e = collectionUrl.substring(collectionUrl.lastIndexOf("/") + 1),
            t = e.substring(e.lastIndexOf("?"));
        collectionUrl = collectionUrl.replace(e, ""), e = e.replace(t, ""), e = e.replace("#", "");
        var i = e.split("+"),
            n = [];
        for (jQuery("#" + filter_id + " li.active-filter").each(function() {
                n.push(jQuery(this).attr("data-handle"))
            }), jQuery("#" + filter_id + " li.active-filter").find("a").attr("title", ""), jQuery("#" + filter_id + " li").removeClass("active-filter"), jQueryi = 0; jQueryi < n.length; jQueryi++) i = jQuery.grep(i, function(e, t) {
            return e !== n[jQueryi]
        });
        var o = i.join("+"),
            a = collectionUrl + o + t;
        window.location = a
    },
    filterCatalog: function() {
        var e = jQuery(".advanced-filter");
        e.each(function() {
            var e = jQuery(this);
            e.data("group");
            e.hasClass("active-filter") && e.parents(".sb-filter").find("a.clear-filter").removeClass("hidden")
        }), e.on("click", function() {
            var e = jQuery(this);
            e.data("group"), e.find("a").attr("href");
            e.hasClass("active-filter")
        }), jQuery(".sb-filter").on("click", ".clear-filter", function(e) {
            var t = jQuery(this).attr("id");
            t = t.replace("clear-", "");
            var i = window.location.href;
            if (i.match(/\?/)) {
                var n = i.substring(i.lastIndexOf("?") - 1);
                if (n.match(/\//)) {
                    var o = n.replace(/\//, "");
                    i = i.replace(n, ""), i += o, AT_Main.filterCatalogReplace()
                } else AT_Main.filterCatalogReplace()
            } else {
                var a = i.substring(i.lastIndexOf("/") + 1);
                i = i.replace(a, ""), a = a.replace("#", "");
                var r = a.split("+"),
                    s = [];
                for (jQuery("#" + t + " li.active-filter").each(function() {
                        s.push(jQuery(this).attr("data-handle"))
                    }), jQuery("#" + t + " li.active-filter").find("a").attr("title", ""), jQuery("#" + t + " li").removeClass("active-filter"), jQueryi = 0; jQueryi < s.length; jQueryi++) r = jQuery.grep(r, function(e, t) {
                    return e !== s[jQueryi]
                });
                var l = r.join("+"),
                    c = i + l;
                window.location = c
            }
        })
    },
    swatch: function() {
        jQuery(".swatch :radio").change(function() {
            var e = jQuery(this).closest(".swatch").attr("data-option-index"),
                t = jQuery(this).val();
            jQuery(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")
        })
    },
    refreshImage: function() {
        jQuery("#gallery-image").length && jQuery("#product-image").on("click", ".thumb-img", function() {
            var e = jQuery(this);
            if (!e.hasClass("active")) {
                var t = e.parents(".product-image-inner"),
                    i = e.attr("data-zoom-image"),
                    n = e.attr("data-image");
                t.find(".thumb-img").removeClass("active"), e.addClass("active"), t.find(".featured-image").find("img").attr("data-zoom-image", i), t.find(".featured-image").find("img").attr("src", n)
            }
            return !1
        })
    },
    refreshZoom: function() {
        jQuery(".featured-image").data("zoom");
        if (jQuery(".elevatezoom").length) {
            var e = jQuery(".elevatezoom .zoom-image");
            e.elevateZoom({
                gallery: "gallery-image",
                galleryActiveClass: "active",
                zoomType: "lens",
                cursor: "pointer",
                lensShape: "round",
                lensSize: 300
            }), jQuery(".elevatezoom").bind("click", function(e) {
                var t = jQuery(".elevatezoom .zoom-image").data("elevateZoom");
                return jQuery.fancybox(t.getGalleryList(), {
                    closeBtn: !1,
                    helpers: {
                        buttons: {}
                    }
                }), !1
            })
        }
    },
    cartJS_handle: function() {
        rivets.bind(jQuery(".templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content"), {
            cart: CartJS.cart
        }), "undefined" != typeof _bc_config && ("true" == _bc_config.enable_multiple_currencies && setTimeout(function() {
            Currency.convertAll("{{ settings.default_currency }}", Currency.currentCurrency)
        }, 50), jQuery(document).on("cart.requestComplete", function(e, t) {
            Shopify.onCartUpdate(CartJS.cart), "undefined" != typeof _bc_config && "true" == _bc_config.enable_multiple_currencies && Currency.convertAll("{{ settings.default_currency }}", Currency.currentCurrency)
        }))
    },
    scareName: function() {
        var e = 0;
        jQuery(".product-wrapper").find("h5.product-name").each(function(t, i) {
            e = jQuery(i).height() > e ? jQuery(i).height() : e
        }), jQuery(".product-wrapper").find("h5.product-name").css("height", e)
    },
    scareScreen: function() {
        if ("undefined" != typeof _bc_config) {
            var e = this;
            "true" == _bc_config.enable_title_blance && this.scareName(), jQuery(document).ajaxComplete(function(t, i, n) {
                "true" == _bc_config.enable_title_blance && e.scareName()
            })
        }
    },
    init: function() {
        return "undefined" == typeof _bc_config ? void console.log(" _bc_config is undefined ") : (this.stickMenu(), this.toTopButton(), this.mailchipPopup(), this.effectNavigation(), this.handleGridList(), this.fancyboxHomeThumbProduct(), this.fixButton(), this.menuOnMobile(), this.handleMenuMultiLine(), this.toggleFilterSidebar(), this.toggleFooter(), this.toggleVerticalMenu(), this.dropdownFilter(), this.fixTitle(), this.filterCatalog(), this.swatch(), this.refreshImage(), this.refreshZoom(), this.cartJS_handle(), void this.scareScreen())
    }
};
jQuery(window).resize(function() {
    AT_Main.getWidthBrowser() < 1024 && jQuery("#top").hasClass("on") && (jQuery("#top").prev().remove(), jQuery("#top").removeClass("on").removeClass("animated")), AT_Main.fixReturnScroll(), 1 != AT_Main.checkLayout() && jQuery(".menu-mobile").hasClass("opened") && jQuery("#page-body").trigger("click")
}), jQuery(document).ready(function(e) {
    jQuery(".templateCart #qs-add-cart").click(function(e) {
        setTimeout(function() {
            window.location.reload()
        }, 2e3)
    }), AT_Main.init()
});